export const ratePlansTab = {
  sectionLabel: {
    title: "Tariffe mostrate nella prenotazione diretta",
    hintHotel:
      "Scegli quali tariffe compaiono per ogni tipo di camera, il loro ordine e quella predefinita.",
    hintApartment:
      "Scegli quali tariffe vede l'ospite, trascina per riordinare e imposta quella predefinita.",
  },
  loading: "Caricamento tariffe…",
  empty: {
    apartment: "Nessuna tariffa configurata per questa struttura.",
    hotel: "Nessun tipo di camera configurato per questo hotel.",
    room: "Nessuna tariffa configurata per questa camera.",
  },
  derivedPill: "Derivata",
  dragHandleTitle: "Trascina per riordinare",
  visibleSwitchTitle: "Mostra nella prenotazione diretta",
  expandTitleClose: "Chiudi impostazioni",
  expandTitleOpen: "Imposta nome, politica e predefinita",
  visibleNameLabel: "Nome visualizzato",
  visibleNamePlaceholderApartment: "Es. Non rimborsabile / Flessibile",
  visibleNamePlaceholderHotel: "Es. Colazione inclusa",
  cond: {
    refundable: "Si può cancellare",
    refundableHint: "Decidi tu fino a quando è gratis.",
    nonRefundable: "Non rimborsabile",
    nonRefundableHint: "Non si rimborsa nulla. L'ospite può cancellare, ma gli si addebita il 100%. Lo vede prima di pagare.",
    freeDays: "Cancellazione gratis fino a",
    freeDaysPlaceholder: "Senza limite",
    freeDaysHelp: "Giorni prima dell'arrivo. Vuoto = gratis fino alla fine.",
    penalty: "Dopo si addebita",
    penaltyHelp: "Sul totale del soggiorno. 100% = non si rimborsa nulla.",
    sinGuardar: "Questa tariffa non ha ancora condizioni salvate. Quella qui sotto è una proposta: premi «Salva politica» per applicarla.",
    aplicarTodas: "Applica a tutte le camere",
    aplicarTodasHelp: "La stessa condizione verrà messa sulla tariffa «{name}» di 1 altra camera. | La stessa condizione verrà messa sulla tariffa «{name}» di altre {count} camere.",
    notes: "Note per l'ospite (facoltativo)",
    previewNonRefundable: "L'ospite leggerà: «Questa tariffa non è rimborsabile: la prenotazione non si può cancellare».",
    previewFree: "L'ospite leggerà: «Cancellazione gratuita fino all'arrivo».",
    previewDayPenalty: "L'ospite leggerà: «Cancellazione gratuita fino al giorno dell'arrivo; dopo si addebita il {pct}%».",
    previewUntilPenalty: "L'ospite leggerà: «Gratis fino a 1 giorno prima; dopo si addebita il {pct}%». | L'ospite leggerà: «Gratis fino a {count} giorni prima; dopo si addebita il {pct}%».",
    shortNonRefundable: "Non rimborsabile",
    shortFree: "Cancellazione gratuita",
    shortDayPenalty: "Gratis fino all'arrivo · poi {pct}%",
    shortUntilPenalty: "Gratis fino a 1 giorno prima · poi {pct}% | Gratis fino a {count} giorni prima · poi {pct}%",
  },
  cancellationPolicyLabel: "Politica di cancellazione",
  policyEmpty: "Nessuna politica impostata",
  policyEdit: "Modifica",
  policyAdd: "Aggiungi",
  defaultLabel: "Predefinita",
  rulesApartment: "Regole: almeno 1 visibile e 1 predefinita (che deve essere visibile).",
  rulesRoom: "Ogni camera deve avere almeno 1 tariffa visibile e 1 predefinita.",
  tip: 'Suggerimento: imposta una tariffa "Flessibile" come predefinita e mostra le altre come "Non rimborsabile".',
  room: {
    ratePlansCount: "{count} tariffa | {count} tariffe",
    includedGuestsTitle: "Quanti ospiti include il prezzo (per il supplemento ospite aggiuntivo)",
    includes: "Include",
    person: "ospite | ospiti",
    meta: "Capacità: {capacity} • Adulti: {adults} • Bambini: {children}",
  },
  modal: {
    eyebrow: "Politica di cancellazione",
    closeAria: "Chiudi",
    hint: "Questo testo verrà mostrato all'ospite nella prenotazione diretta. Descrivi le condizioni di cancellazione per questa tariffa.",
    textareaPlaceholder:
      "Es. Cancellazione gratuita fino a 48h prima del check-in. Dopodiché viene addebitata la prima notte. Non rimborsabile in alta stagione.",
    clear: "Cancella",
    cancel: "Annulla",
    saving: "Salvataggio…",
    save: "Salva politica",
    defaultTitle: "Tariffa",
  },
  toasts: {
    loadError: "Impossibile caricare le tariffe.",
    saveSuccess: "Tariffe salvate correttamente.",
    saveError: "Impossibile salvare le tariffe.",
  },
  validation: {
    roomMinVisible: 'La camera "{name}" deve avere almeno 1 tariffa visibile.',
    roomOneDefault: 'La camera "{name}" deve avere esattamente 1 tariffa predefinita.',
    roomDefaultVisible: 'In "{name}" la tariffa predefinita deve essere visibile.',
    minVisible: "Devi mantenere almeno 1 tariffa visibile.",
    oneDefault: "Deve esserci esattamente 1 tariffa predefinita.",
    defaultVisible: "La tariffa predefinita deve essere visibile.",
  },
};
